import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { applyConfigsSchema } from '@api/schemaConfig';

import { IOnSuccess } from '@interfaces/common/handlers';

import { refetchOptions } from '@constants/common';
import { APPLY_CONFIGS_SCHEMA, MAVENIR_SCHEMA_CONFIG } from '@constants/queryKeys';

interface IApplyConfigsReturnType {
	isLoadingApplyConfigs: boolean;
	applyConfigs: () => void;
}

const useMutateApplyConfigs = (props?: IOnSuccess): IApplyConfigsReturnType => {
	const queryClient = useQueryClient();

	const { onSuccess } = props || {};

	const {
		mutate: applyConfigs,
		isLoading,
	} = useMutation({
		mutationKey: [APPLY_CONFIGS_SCHEMA],
		mutationFn: applyConfigsSchema,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG])];
		},
		...refetchOptions,
	});

	return {
		applyConfigs,
		isLoadingApplyConfigs: isLoading,
	};
};

export default useMutateApplyConfigs;
